export default class BreakingTables {
    constructor() {
        $(document).ready(() => {
            this.tables = document.querySelectorAll('.breaking-table');

            this.prepareTables();
        });
    }

    prepareTables() {
        this.tables.forEach((table) => {
            let headerCells = [];
            let otherCells = [];

            if (table.classList.contains('has-header-row')) {
                headerCells = table.querySelectorAll('tr:first-child td');
                otherCells = table.querySelectorAll('tr:not(:first-child) td');

                otherCells.forEach((cell) => {
                    const columnIndex = [...cell.parentNode.children].indexOf(cell);
                    const { dataset } = cell;
                    dataset.title = headerCells[columnIndex].textContent.trim();
                });
            } else if (table.classList.contains('has-header-column')) {
                headerCells = table.querySelectorAll('td:first-child');
                otherCells = table.querySelectorAll('td:not(:first-child)');
                const rows = table.querySelectorAll('tr');

                rows.forEach((row) => {
                    const rowIndex = [...row.parentNode.children].indexOf(row);
                    const { dataset } = row;
                    dataset.title = headerCells[rowIndex].textContent.trim();
                });
            }

            headerCells.forEach((element) => {
                element.classList.add('only-mid-up');
            });
        });
    }
}
